import { render, staticRenderFns } from "./WhyBaron.vue?vue&type=template&id=e627a744&scoped=true"
import script from "./WhyBaron.vue?vue&type=script&lang=js"
export * from "./WhyBaron.vue?vue&type=script&lang=js"
import style0 from "./WhyBaron.vue?vue&type=style&index=0&id=e627a744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e627a744",
  null
  
)

export default component.exports